const drawerWidth = 260; //largeur du sidebar
const marginCard = 20; //margin de contour de la card principale


export const ConstantsContent = {
    DrawerWidth: drawerWidth,
    MarginCard: marginCard
};

export default ConstantsContent;